export const DAYS_OF_WEEK = [
  { value: 1, label: "Lun" },
  { value: 2, label: "Mar" },
  { value: 3, label: "Mié" },
  { value: 4, label: "Jue" },
  { value: 5, label: "Vie" },
  { value: 6, label: "Sáb" },
  { value: 0, label: "Dom" },
];

export const TIME_TYPES = [
  { value: "before", label: "Antes de" },
  { value: "exactly", label: "A las" },
  { value: "after", label: "Después de" },
];

export function normalizePreferredDays(days) {
  if (!Array.isArray(days)) return [];
  
  const strToNum = {
    monday: 1, tuesday: 2, wednesday: 3, thursday: 4,
    friday: 5, saturday: 6, sunday: 0
  };

  return days
    .map((d) => {
      if (!d) return null;
      let val = d.day_of_week;
      if (typeof val === "string") val = strToNum[val.toLowerCase()] ?? val;
      return { ...d, day_of_week: val };
    })
    .filter((d) => d && typeof d.day_of_week === "number")
    .map((d) => ({
      day_of_week: d.day_of_week,
      preferred_time_type: d.preferred_time_type || null,
      preferred_time: d.preferred_time
        ? String(d.preferred_time).slice(0, 5)
        : null,
    }));
}

export function formatPreferredDay(day) {
  const label =
    DAYS_OF_WEEK.find((d) => d.value === day.day_of_week)?.label ||
    day.day_of_week;
  if (day.preferred_time_type && day.preferred_time) {
    const type =
      TIME_TYPES.find((t) => t.value === day.preferred_time_type)?.label ||
      day.preferred_time_type;
    return `${label}: ${type} ${day.preferred_time}`;
  }
  return label;
}

export function PreferredDaysEditor({
  preferredDays,
  onToggleDay,
  onUpdateDay,
  onClear,
  disabled,
  availableDays,
}) {
  return (
    <div className="reg-field">
      <div className="reg-days-header">
        <span className="reg-label">Días preferidos (opcional)</span>
        {preferredDays.length > 0 && (
          <button
            type="button"
            className="reg-days-clear"
            onClick={onClear}
            disabled={disabled}
          >
            Limpiar
          </button>
        )}
      </div>
      <div className="reg-days-toggle" role="group" aria-label="Días de la semana">
        {DAYS_OF_WEEK.map((day) => {
          if (availableDays && !availableDays.includes(day.value)) {
            return null; // Skip days not available in the league
          }
          const active = preferredDays.some((d) => d.day_of_week === day.value);
          return (
            <button
              key={day.value}
              type="button"
              className={`reg-day-chip${active ? " active" : ""}`}
              onClick={() => onToggleDay(day.value)}
              disabled={disabled}
              aria-pressed={active}
            >
              {day.label}
            </button>
          );
        })}
      </div>

      {preferredDays.length > 0 && (
        <div className="reg-days-details">
          {preferredDays.map((day) => {
            const dayLabel =
              DAYS_OF_WEEK.find((d) => d.value === day.day_of_week)?.label ||
              day.day_of_week;
            return (
              <div key={day.day_of_week} className="reg-day-detail">
                <span className="reg-day-detail-label">{dayLabel}</span>
                <div className="reg-day-detail-row">
                  <select
                    value={day.preferred_time_type || ""}
                    onChange={(e) =>
                      onUpdateDay(
                        day.day_of_week,
                        "preferred_time_type",
                        e.target.value
                      )
                    }
                    disabled={disabled}
                  >
                    <option value="">Cualquier hora</option>
                    {TIME_TYPES.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                  <input
                    type="time"
                    value={day.preferred_time || ""}
                    onChange={(e) =>
                      onUpdateDay(
                        day.day_of_week,
                        "preferred_time",
                        e.target.value
                      )
                    }
                    disabled={disabled || !day.preferred_time_type}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
